import { useEffect } from "react";

import { interfMessage } from "../interfaces";

export default function useToastMessage(
    message: interfMessage,
    onRemoveMessage: (id: number) => void,
) {
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onRemoveMessage(message.id!)
        }, message.duration || 5000)

        return () => {
            clearTimeout(timeoutId);
        }
    }, [message, onRemoveMessage]);

    function handleRemoveToast() {
        onRemoveMessage(message.id!);
    }

    return {
        handleRemoveToast,
    }
}